<template lang="pug">
  .settings(v-if='settings')
    span
      | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}:
      | {{ digitCapacityMode }}
    br
    span
      | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
      | {{ settings.infinityAmountOfExamples ? $i18n.t('trainer.trainer_gameFormSetting_infiniteAmountOfExamples') : settings.numOfExamples }}
    br
    span(v-if="settings.timeLimit")
      | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}:
      | {{ timeLimit }}
    br(v-if="settings.timeLimit")
    span
      | {{ $i18n.t('trainer.trainer_gameFormSetting_coloredNumbers') }}:
      | {{ getTitleForSetting(settings.coloredNumbers) }}
    br
    slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        data() {
            return {
                digitalCapacityModes: [
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        value: 2,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        value: 3,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        value: 4,
                    },
                ],
            };
        },
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            withIcon: Boolean,
        },
        methods: {
            getTitleForSetting(setting) {
                return setting
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated');
            },
        },
        computed: {
            digitCapacityMode() {
                return this.digitalCapacityModes.find(
                    digitCapacityMode => digitCapacityMode.value === +this.settings.digitCapacity
                ).label;
            },
            timeLimit() {
                return (
                    this.settings.timeLimit +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.settings.timeLimit)
                );
            },
        },
    };
</script>
